





































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
const cssPrefix = 'manageguid';

@Component({
  components: {
    ...UUIFComponent,
    SwTextfield,
  },
})

export default class ManageGuidDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showManageGuidDialog: boolean;
  @Prop()
  modalValues: any;
  guidValue: string = '';
  guidError: boolean = false;
  mounted() {
    this.guidValue = this.modalValues.guid;
    document.addEventListener('keyup', (event : any) => {
      if (event.keyCode === 13) {
        this.onClickSubmit();
      }
    });
    this.setFocusTextField();
  }
  closeDialog(value: boolean = false) {
    this.guidValue = '';
    this.guidError = false;
    console.warn(value);
    this.$emit('closeDialog');
  }
  editGuid() {
    this.guidError = false;
    if (this.guidValue !== '') {
      const request = {
        guidBody: {
          userName: JSON.parse(this.$store.getters.getUserInfo).user.userId,
          guid: this.guidValue,
        },
        serNo: this.modalValues.serialNumber,
      };
      this.$store.dispatch('MswProductsStoreModule/updateGUID', request)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.msgCode === 'MSWAPP:GUIDUPDATED' && res.operationStatus === 'OK') {
            const changedGUID = this.guidValue;
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
            this.$store.commit('MswProductsStoreModule/editProduct', { property: 'GUID', with: changedGUID });
            this.closeDialog(true);
          }  else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
            this.closeDialog();
          }
        });
    } else {
      this.guidError = true;
    }
  }
  deleteGuid() {
    const request = {
      serNo: this.modalValues.serialNumber,
      userName: JSON.parse(this.$store.getters.getUserInfo).user.userId,
    };
    this.$store.dispatch('MswProductsStoreModule/deleteGUID', request)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.msgCode === 'MSWAPP:GUIDDELETED' && res.operationStatus === 'OK') {
          const changedGUID = '';
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
          this.$store.commit('MswProductsStoreModule/editProduct', { property: 'GUID', with: changedGUID });
          this.closeDialog(true);
        }  else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
          this.closeDialog();
        }
      });
  }
  onClickSubmit() {
    if (this.modalValues.mode === 'del') {
      this.deleteGuid();
    } else {
      this.editGuid();
    }
  }
  setFocusTextField() {
    if (this.$refs.editGuidRef as SwTextfield) {
      (this.$refs.editGuidRef as SwTextfield).focus();
    }
  }
}
